import { useExperimentStore, useRoutingStore, useUserStore } from '@/helpers/composables/useStores';
import { useMounted } from '@vueuse/core';
import { computed, onUnmounted, watch } from 'vue';
import { StarterPageExpName, StarterPageExpVariants } from '..';
import { OnboardingStatus } from '@/enums/onboarding-status';
import { SnowplowContext, SnowplowExperimentContext, SnowplowPageTypeContext } from '@/helpers/tracking/providers';

let starterPageExpActive = false;

export function getStarterPageExpStatus(
	experimentName: string,
	baseContexts: SnowplowContext[] = [],
	activeRouteName?: string
): SnowplowExperimentContext['status'] {
	if (experimentName === StarterPageExpName) {
		let correctPage = false;
		const pageContexts = baseContexts.find(context => context.__name == 'PageTypeContext');
		if (pageContexts) {
			correctPage = (pageContexts as SnowplowPageTypeContext)?.['pageType'] === 'VIEW_HOME_GLOBAL';
		} else {
			correctPage = activeRouteName === 'app.home';
		}
		if (starterPageExpActive && correctPage) {
			return 'ACTIVE';
		}
		return 'ACQUIRED';
	}

	return null;
}

export function useStartingPageExp(main: boolean = false) {
	const { activeVariantsWithControlGroup } = useExperimentStore();
	const { activeRoute } = useRoutingStore();
	const { onboardingStatus } = useUserStore();
	const isMounted = useMounted();

	const startingPageExpActiveVariant = computed(() => {
		if (
			!isMounted.value ||
			activeRoute.value.name !== 'app.home' ||
			onboardingStatus.value !== OnboardingStatus.GLOBAL
		) {
			return undefined;
		}
		return activeVariantsWithControlGroup.value[StarterPageExpName] as StarterPageExpVariants | undefined;
	});

	const startingPageExpActiveVariantForUI = computed(() => {
		if (!isMounted.value || onboardingStatus.value !== OnboardingStatus.GLOBAL) {
			return undefined;
		}
		return activeVariantsWithControlGroup.value[StarterPageExpName] as StarterPageExpVariants | undefined;
	});

	if (main) {
		watch(startingPageExpActiveVariantForUI, newValue => {
			if (newValue) {
				starterPageExpActive = true;
			} else {
				setTimeout(() => {
					starterPageExpActive = false;
				}, 0);
			}
		});
		onUnmounted(() => {
			if (main) {
				starterPageExpActive = false;
			}
		});
	}

	return {
		startingPageExpActiveVariant,
		startingPageExpActiveVariantForUI,
	};
}
